/* eslint-disable */
export default {
  removeMeetingWarning:
    'De planningsfunctie is niet meer beschikbaar. Gebruik de {app} om uw videomeetings te plannen.',
  scheduleMeetingTips:
    'We hebben meetings verwijderd uit deze app. Als u meetings wilt gebruiken, raden we de {app} aan.',
  migrateToPluginAlert:
    'Opmerking: deze app werkt niet met Outlook versie 2016 en ouder of Internet Explorer 11. Upgrade uw Outlook of stap over naar Microsoft Edge, of stap eventueel over naar {app}',
} as const;

// @key: @#@"removeMeetingWarning"@#@ @source: @#@"The scheduling feature is discontinued. Please use the {app} to schedule your video meetings."@#@
// @key: @#@"scheduleMeetingTips"@#@ @source: @#@"Please note that we removed meetings from this app. To use meetings, we recommend the {app}."@#@
// @key: @#@"migrateToPluginAlert"@#@ @source: @#@"Note: This app will not work with Outlook version 2016 and below and Internet Explorer 11. Please upgrade your Outlook or switch to Microsoft Edge, or alternately, switch to {app}"@#@
